import { ModalComponent } from "../../../components/modal"
import { Document, Page, pdfjs } from "react-pdf"; // Biblioteca para exibir PDFs
import "react-pdf/dist/esm/Page/AnnotationLayer.css"
import useAuth from "../../../context/auth";
import { useState } from "react";
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

interface IProps {
    open: boolean,
    onClose: () => void,

}
export const ModalContract = ({ onClose, open }: IProps) => {
    const { user } = useAuth();
    const [numPages, setNumPages] = useState<number | null>(null);

    const pdfUrl = user?.actualContract?.contract?.contractFileUrl as string

    return (
        <ModalComponent title="Visualizar contrato" open={open} onClose={onClose}>
            <div style={{ width: "100%", overflowY: "auto" }}>
                <Document
                    file={{ url: pdfUrl }}
                    onLoadSuccess={({ numPages }) => setNumPages(numPages)}
                    onLoadError={(error) => console.error(error)}
                >
                    {numPages &&
                        Array.from(new Array(numPages), (_, index) => (
                            <Page
                                key={index + 1}
                                pageNumber={index + 1}
                                renderTextLayer={false} // Melhor desempenho desativando a camada de texto se não for necessária
                                width={window.innerWidth * 0.83} // Torna o PDF responsivo
                            />
                        ))}
                </Document>
            </div>
        </ModalComponent>
    );
};